import { Ban, BellRing } from 'lucide-react';

import { DisruptionNotificationEnum, DisruptionNotificationGracePeriodEnum } from 'src/graphql/schema';

export const disruptedNotificationsOptions = [
  {
    label: 'No notifications',
    value: DisruptionNotificationEnum.NoNotifications,
  },
  {
    label: 'Send notification',
    value: DisruptionNotificationEnum.SendNotification,
  },
];

export const disruptedNotificationsOptionsRich = [
  {
    label: 'No notifications',
    value: DisruptionNotificationEnum.NoNotifications,
    icon: Ban,
  },
  {
    label: 'Send notifications',
    value: DisruptionNotificationEnum.SendNotification,
    icon: BellRing,
  },
];

export const disruptedNotificationsOptionsDictionary = disruptedNotificationsOptions.reduce(
  (acc, { value, label }) => ({ ...acc, [value]: label }),
  {} as Record<DisruptionNotificationEnum, string>,
);

export const disruptedNotificationsOptionsRichDictionary = disruptedNotificationsOptionsRich.reduce(
  (acc, { value, label, icon }) => ({ ...acc, [value]: { label, icon } }),
  {} as Record<DisruptionNotificationEnum, { label: string; icon: React.ElementType }>,
);

export const gracePeriodOptions = [
  {
    label: 'Immediate notification',
    value: DisruptionNotificationGracePeriodEnum.Immediate,
  },
  {
    label: '24 hour grace period',
    value: DisruptionNotificationGracePeriodEnum.TwentyFourHours,
  },
  {
    label: '7 day grace period',
    value: DisruptionNotificationGracePeriodEnum.SevenDays,
  },
  {
    label: '30 day grace period',
    value: DisruptionNotificationGracePeriodEnum.ThirtyDays,
  },
];

export const gracePeriodOptionsDictionary = gracePeriodOptions.reduce(
  (acc, option) => ({ ...acc, [option.value]: option }),
  {},
) as Record<string, { label: string; value: string }>;
